<script>
    import { onMount } from "svelte";
    import { checkTokenExpiration } from "../../Utils/utilFunctions.svelte";
    import SurgeryRooms from "../../Pages/SurgeryRooms/SurgeryRooms.svelte";

    export let tokenRefresh = undefined;
    export let params;

    onMount(async () => {
        tokenRefresh = checkTokenExpiration();
    });
</script>

{#await tokenRefresh then tokenRefreshResult}
    {#if tokenRefreshResult === "valid" || tokenRefreshResult === "refreshed"}
        <div class="flex flex-1 flex-col w-full px-6 py-4 bg-gray-200">
            <SurgeryRooms {params} />
        </div>
    {/if}
{/await}
